import { type ObjectValuesUnionType } from '../utils/typing';

export const CustomBetTemplates = Object.freeze({
  SOCCER_SCORERS: 'SOCCER_SCORERS',
  MULTICHOICE_MM_SOCCER_SCORERS: 'MULTICHOICE_MM_SOCCER_SCORERS',
  SOCCER_GOAL_TYPE: 'SOCCER_GOAL_TYPE',
  SOCCER_COMPETITOR_GOAL_TYPE: 'SOCCER_COMPETITOR_GOAL_TYPE',
  SOCCER_VERSUS: 'SOCCER_VERSUS',
  SOCCER_SCORERS_AND_TEAM_WINS: 'SOCCER_SCORERS_AND_TEAM_WINS',
  SOCCER_SCORERS_OVERTIME: 'SOCCER_SCORERS_OVERTIME',
  SOCCER_SCORERS_PERIOD: 'SOCCER_SCORERS_PERIOD',
  SOCCER_MULTIPLE_SCORERS: 'SOCCER_MULTIPLE_SCORERS',
  SOCCER_CARD_PLAYER: 'SOCCER_CARD_PLAYER',
  SOCCER_PLAYER_PROPS: 'SOCCER_PLAYER_PROPS',
  SOCCER_DECISIVE_PLAYERS: 'SOCCER_DECISIVE_PLAYERS',
  RUGBY_SCORERS: 'RUGBY_SCORERS',
  RUGBY_MULTIPLE_SCORERS: 'RUGBY_MULTIPLE_SCORERS',
  MULTICHOICE_MM_RUGBY_SCORERS: 'MULTICHOICE_MM_RUGBY_SCORERS',
  ICE_HOCKEY_SCORERS: 'ICE_HOCKEY_SCORERS',
  ICE_HOCKEY_MULTIPLE_SCORERS: 'ICE_HOCKEY_MULTIPLE_SCORERS',
  MULTICHOICE_MM_ICE_HOCKEY_SCORERS: 'MULTICHOICE_MM_ICE_HOCKEY_SCORERS',
  FOOTBALL_SCORERS: 'FOOTBALL_SCORERS',
  MULTICHOICE_MM_FOOTBALL_SCORERS: 'MULTICHOICE_MM_FOOTBALL_SCORERS',
  BASKETBALL_POINT_PLAYER: 'BASKETBALL_POINT_PLAYER',
  BASKETBALL_PLAYER_OVER_UNDER: 'BASKETBALL_PLAYER_OVER_UNDER',
  HANDBALL_SCORERS_PLAYER: 'HANDBALL_SCORERS_PLAYER',
  BASKETBALL_HEAD_TO_HEAD: 'BASKETBALL_HEAD_TO_HEAD',
});

export type CustomBetTemplate = ObjectValuesUnionType<typeof CustomBetTemplates>;
